import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { reactI18nextModule } from "react-i18next";

// Import the translations from components.
import CommonTranslations from "./commonTranslations";

const settings = {
  fallbackLng: "en",
  debug: true,
  interpolation: {
    escapeValue: false,
  },
  react: {
    wait: false,
    bindI18n: "languageChanged loaded",
    bindStore: "added removed",
    nsMode: "default",
  },
  resources: CommonTranslations
};

window.i18n = i18n
  .use(LanguageDetector)
  .use(reactI18nextModule)
  .init(settings);

// Export this handy utility function which takes the translation file from
// a component and adds it to the resource.
export function addTranslation(translation) {
  Object.keys(translation).forEach(languageCode => {
    const namespaces = translation[languageCode];
    Object.keys(namespaces).forEach(namespace => {
      i18n.addResourceBundle(
        languageCode,
        namespace,
        translation[languageCode][namespace],
        // Merge instead of overwrite entire namespace.
        true,
        // Overwrite existing keys.
        true
      );
    });
  });
}

/**
 * Helper method to add translation bundles deeply nested.
 * Given a string in the form of: "generate:object:nested:deep" and an
 * object in the form of:
 * {
 *  en: {
 *    translationKey: "translation shown"
 *  }
 * }
 * Nest the language code key deep within the given key and register the
 * translation bundle.
 * @param {String} key
 * @param {Object} translation
 */
export function addTranslationAtKey(key, translation) {
  const keys = key.split(":");
  const bundle = {};
  let bundlePointer = bundle;
  const lastKeyIndex = keys.length - 1;
  Object.keys(translation).forEach(langCode => {
    if (i18n.hasResourceBundle(langCode, key)) {
      // throw new Error(
      //   `i18n: The namespace ${key} in language ${langCode} conflicts with an existing namespace.`
      // );
    }

    bundle[langCode] = {};
    bundlePointer = bundle[langCode];

    for (let i = 0; i < lastKeyIndex; i += 1) {
      const pathKey = keys[i];
      if (!(pathKey in bundlePointer)) {
        bundlePointer[pathKey] = {};
      }
      bundlePointer = bundlePointer[pathKey];
    }
    bundlePointer[keys[lastKeyIndex]] = translation[langCode];
  });

  addTranslation(bundle);
}

export default i18n;
